import { jsx as _jsx } from "react/jsx-runtime";
import { useStateStrict, useMergedRef } from "@ajayvikas/react-common";
import React from "react";
export const WEBKIT_AUTO_FILL_COLOR = "rgb(232, 240, 254)";
const isAutofill = (input) => {
    try {
        //:-internal-autofill-selected??
        //TODO: Check the safari psuedo class
        return input.matches(":-webkit-autofill");
    }
    catch {
        return false;
    }
};
export const Input = React.forwardRef((props, forwardedRef) => {
    const { onChange, onBlur, onKeyDown, __fireOnChangeOnUnmount, ...rest } = props;
    const [value, setValue] = useStateStrict(props.value ?? "");
    const ref = React.useRef(null);
    const mergedRef = useMergedRef(ref, forwardedRef);
    React.useEffect(() => {
        setValue(props.value ?? "");
    }, [props.value, setValue]);
    const onInputChange = (e) => {
        setValue(e.target.value);
        if (document.activeElement === ref.current)
            return;
        requestAnimationFrame(() => {
            if (ref.current && isAutofill(ref.current)) {
                onChange?.(e.target.value);
                // onBlur?.(e as any);
            }
            //Alternate method of detecting auth fill. However it depends on 
            //background color of the browser and not that robust.
            //Also require a reflow/reflow of screen, making it slower
            // const style = window.getComputedStyle(ref.current!);
            // if (style.backgroundColor === WEBKIT_AUTO_FILL_COLOR) {
            //     console.log(NAME, "Firing blur event");
            //     props.onChange?.(e.target.value);
            // }
        });
    };
    const onInputBlur = (e) => {
        if (value !== props.value)
            onChange?.(value);
        onBlur?.(e);
    };
    const onInputKeyDown = (e) => {
        onKeyDown?.(e);
        if (e.defaultPrevented) {
            if (value !== props.value)
                onChange?.(value);
        }
    };
    return _jsx("input", { ...rest, ref: mergedRef, onChange: onInputChange, onBlur: onInputBlur, onKeyDown: __fireOnChangeOnUnmount ? onInputKeyDown : onKeyDown, value: value });
});
